import { render, staticRenderFns } from "./CourseDescription.vue?vue&type=template&id=8158c2e4&"
import script from "./CourseDescription.vue?vue&type=script&lang=js&"
export * from "./CourseDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports